import React from 'react';
import { useNavigate } from 'react-router';
import PropTypes from 'prop-types';
import {
  Badge,
  Box,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  SwipeableDrawer,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Close } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import './style.css';
import { useMenuOptions } from './useMenuOptions';
import { useIsAuthenticated } from '../../hooks/useIsAuthenticated';
import { StyledListItem } from './style';

function ElementList({ setIsDrawerOpen, elements, areNewNotifications }) {
  const navigate = useNavigate();
  const { authenticatedMenuOptions, unauthenticatedMenuOptions } = useMenuOptions({
    areNewNotifications,
  });
  const isAuthenticated = useIsAuthenticated();

  const userOptions = isAuthenticated ? authenticatedMenuOptions : unauthenticatedMenuOptions;

  return (
    <Box
      sx={{ width: '100vw' }}
      role="presentation"
      onClick={() => setIsDrawerOpen(false)}
      onKeyDown={() => setIsDrawerOpen(false)}>
      <List>
        <ListItem>
          <ListItemButton sx={{ justifyContent: 'right' }}>
            <ListItemIcon sx={{ minWidth: 0 }}>
              <Close />
            </ListItemIcon>
          </ListItemButton>
        </ListItem>
        {elements.map(({ id, route, name, onClick }) => (
          <ListItem key={id} disablePadding>
            <ListItemButton onClick={onClick ?? (() => navigate(route))}>
              <ListItemText primary={name} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
      <List>
        {userOptions.map(({ id, route, name, onClick, accent }) => (
          <StyledListItem key={id} disablePadding accent={accent ? 'true' : ''}>
            <ListItemButton onClick={onClick ?? (() => navigate(route))}>
              <ListItemText primary={name} />
            </ListItemButton>
          </StyledListItem>
        ))}
      </List>
    </Box>
  );
}

ElementList.propTypes = {
  setIsDrawerOpen: PropTypes.func.isRequired,
  elements: PropTypes.arrayOf(Object).isRequired,
  areNewNotifications: PropTypes.bool.isRequired,
};

function MobileMenu({ elements }) {
  const { areNewNotifications } = useSelector((store) => store.notifications);
  const [isDrawerOpen, setIsDrawerOpen] = React.useState(false);

  return (
    <>
      <IconButton style={{ width: '4rem' }} onClick={() => setIsDrawerOpen(true)}>
        <Badge
          badgeContent={' '}
          color="warning"
          invisible={!areNewNotifications}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}>
          <MenuIcon />
        </Badge>
      </IconButton>
      <SwipeableDrawer
        ModalProps={{
          keepMounted: true,
        }}
        anchor="right"
        variant="temporary"
        open={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        onOpen={() => setIsDrawerOpen(true)}>
        <ElementList
          setIsDrawerOpen={setIsDrawerOpen}
          elements={elements}
          areNewNotifications={areNewNotifications}
        />
      </SwipeableDrawer>
    </>
  );
}

export default MobileMenu;

MobileMenu.propTypes = {
  elements: PropTypes.arrayOf(Object).isRequired,
};
